module.exports = __webpack_public_path__ + "img/katarina_living_room_2.ead45498.jpg";